import { render, staticRenderFns } from "./CustomerFilesPage.vue?vue&type=template&id=f714909e&scoped=true&"
import script from "./CustomerFilesPage.vue?vue&type=script&lang=js&"
export * from "./CustomerFilesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f714909e",
  null
  
)

export default component.exports